import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface BreadcrumbItemProps {
  text: string | undefined;
  linkTo?: string;
  active?: boolean;
  linkClassName?: string;
}

export const BreadcrumbItem = ({
  text,
  linkTo,
  active,
  linkClassName,
}: BreadcrumbItemProps) => {
  return (
    <div className="breadcrumb-item flex items-center relative">
      <Link
        to={`${linkTo ? linkTo : '#'}`}
        className={twMerge(
          'text-blue-396AFC text-sm font-medium',
          active && 'text-gray-A1A1A1 hover:cursor-default',
          linkClassName,
        )}
      >
        {text ? text : ''}
      </Link>
    </div>
  );
};
